import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { Permission } from 'legacy/common/types'

export const useIsReadOnly = (): boolean => {
  const hasAccess = useAccessControl()
  return hasAccess({ permissions: [Permission.ReadOnly] })
}
